import React from 'react';
import SimpleReportForm from '../SimpleReportForm';
import GenericSurepassOutputComponent from '../output/GenericSurepassOutputComponent';

const ItrGetAisInputComponent = () => (
    <SimpleReportForm
        banner={{ icon: 'pi-file', title: 'ITR Get AIS', subtitle: 'Fetch Annual Information Statement (AIS) for an ITR client' }}
        fields={[
            { name: 'client_id', label: 'Client ID', icon: 'pi-key', placeholder: 'itr_xxxxxxxxxxxxx', maxLength: 100, mono: true },
            { name: 'financial_year', label: 'Financial Year', icon: 'pi-calendar', placeholder: '2024-25', maxLength: 10, mono: true },
        ]}
        endpoint={{
            path: '/surepass/itr/get-ais',
            bodyMapper: (v, sid) => ({ client_id: v.client_id.trim(), financial_year: v.financial_year.trim(), api_provider_service_id: parseInt(sid, 10) }),
        }}
        consentReportType="itr-get-ais"
        submitLabel="Fetch AIS"
        successSummary="AIS fetched"
        errorSummary="AIS fetch failed"
        confirmHeader="Confirm AIS fetch"
        confirmAcceptLabel="Yes, fetch"
        outputComponent={GenericSurepassOutputComponent}
        outputProps={{ title: 'ITR Annual Information Statement', icon: 'pi-file' }}
    />
);

export default ItrGetAisInputComponent;
